export default __webpack_public_path__ + "static/media/WorkoutBuddyDemo.6ceb23d1.mov";